import './fixedAvatar.scss'
import createHttp from '../../../../../frontend-lib/tools/axios.js'
import {
  getEnvHost,
  getPlatform
} from '../../../../..//frontend-lib/tools/getPlatform.js'
const http = createHttp()
const prefix = getEnvHost('//m.xinli001.com/')
const classNamePrefix = 'lesson-play-consult-fixed-teacher'
// 单课时时生成红点，点击后消除
const zixunRed = 'zixun-red'
const zixunRedKey = 'red_zixun'

async function fetchCoupon(coupon_id, cd) {
  try {
    const res = await http.get(
      `${prefix}coupon/auto_receive_coupon?coupon_id=${coupon_id}`
    )

    const { code, data, message } = res.data
    if (code === 40001) {
      window.toast(message, 2000, () => {
        const { isYixinliApp } = getPlatform()
        if (isYixinliApp) {
          window.location.href = 'yixinli://open_user_login'
        } else {
          window.location.href = `${prefix}/account/login?next=${encodeURIComponent(
            window.location.href
          )}`
        }
      })
    } else {
      cd(data, code)
    }
  } catch (e) {
    console.error(e)
  }
}
const defaultAvatar =
  'https://ossimg.xinli001.com/20210625/cdef27a3a93800ee381ed11cc027d69a.jpeg'
const render = (outer, store, oneClick) => {
  const { teacherList, showIndex, isShowTips } = store
  const item = teacherList[showIndex % teacherList.length]

  const html = `
    <div class="${classNamePrefix}-desc ${isShowTips ? '' : 'hide'}">
      <div class="${classNamePrefix}-desc-inner">
        <p>${item.copywriting}</p>
      </div>
      <div class="${classNamePrefix}-close"></div>
    </div>
    <div class="${classNamePrefix}-avatar">
      <img data-src="${item.avatar || defaultAvatar}" src="${item.avatar ||
    defaultAvatar}?x-oss-process=image/resize,w_100" />
    </div>
  `

  outer.innerHTML = html

  const teacher = document.querySelector(`.${classNamePrefix}`)

  teacher.addEventListener('click', async () => {
    if (typeof oneClick === 'function') {
      try {
        await fetchCoupon(store.coupon_id, oneClick)
      } finally {
        oneClick = null
      }
    }
    store.showDetail()
    removeRedAfter(teacher)
  })

  document
    .querySelector(`.${classNamePrefix}-close`)
    .addEventListener('click', e => {
      e.stopPropagation()
      store.tipsClose()
    })

  return html
}
const createRedAfter = () => {
  if (!window.localStorage.getItem(zixunRedKey)) {
    return ' ' + zixunRed
  }
  return ''
}
const removeRedAfter = dom => {
  if (!window.localStorage.getItem(zixunRedKey)) {
    dom.classList.remove(zixunRed)
    window.localStorage.setItem(zixunRedKey, 1)
  }
}
export default (store, oneClick) => {
  const outer = document.createElement('div')
  outer.setAttribute('class', classNamePrefix + createRedAfter())

  document.body.appendChild(outer)

  render(outer, store, oneClick)

  return {
    update: () => {
      const { teacherList, showIndex, isShowTips, isScrolling } = store
      const item = teacherList[showIndex % teacherList.length]

      if (!isShowTips) {
        document.querySelector(`.${classNamePrefix}-desc`).classList.add('hide')
      }

      const avatar = document.querySelector(`.${classNamePrefix}-avatar img`)
      const nowAvatar = avatar.getAttribute('data-src')
      if (nowAvatar !== item.avatar) {
        avatar.setAttribute('src', item.avatar)
        avatar.setAttribute('data-src', item.avatar)
      }

      console.log(
        `isScrolling ? 'contains' : 'remove'`,
        isScrolling ? 'contains' : 'remove'
      )
      document
        .querySelector(`.${classNamePrefix}`)
        .classList[isScrolling ? 'add' : 'remove']('scrolling')
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/consult/fixedAvatar.js